const servicesData = [
    {
        id:"1",
        icon:require("../../assets/icons/s1.svg").default,
        number:require("../../assets/icons/01.svg").default,
        title:"Property Sales",
        details:"Looking to buy or sell a property? Our dedicated sales team is here to help you navigate the real estate market with ease. From conducting market research to negotiating the best deals, we'll ensure a smooth and successful transaction."
    },
    {
        id:"2",
        icon:require("../../assets/icons/s2.svg").default,
        number:require("../../assets/icons/02.svg").default,
        title:"Property Rentals",
        details:"Finding the perfect rental property can be a daunting task. Let us take the stress out of your search. Whether you're looking for a short-term lease or a long-term rental, we'll work closely with you to find a property that meets your needs and fits your budget."
    },
    {
        id:"3",
        icon:require("../../assets/icons/s3.svg").default,
        number:require("../../assets/icons/03.svg").default,
        title:"Property Management",
        details:"Managing rental properties can be time-consuming and challenging. Our property management services are designed to make your life easier. From tenant screening to booking collection to maintenance, we'll handle all aspects of property management so you can enjoy passive income without the hassle."
    },
    {
        id:"4",
        icon:require("../../assets/icons/s4.svg").default,
        number:require("../../assets/icons/04.svg").default,
        title:"Investment Consultancy",
        details:"Interested in real estate investment? Our investment consultancy services can help you maximize your returns and minimize your risks. Whether you're a seasoned investor or a first-time buyer, we'll provide you with expert advice and tailored investment solutions to help you achieve your financial goals."
    },
    {
        id:"5",
        icon:require("../../assets/icons/s5.svg").default,
        number:require("../../assets/icons/05.svg").default,
        title:"Real Estate Valuation",
        details:"Understanding the value of a property is essential whether you're buying, selling, or investing. Our real estate valuation services provide accurate and comprehensive property valuations based on market trends, property condition, and other relevant factors."
    },
    {
        id:"6",
        icon:require("../../assets/icons/s6.svg").default,
        number:require("../../assets/icons/06.svg").default,
        title:"Legal Assistance",
        details:"Navigating the legal complexities of real estate transactions can be daunting. Our legal assistance services are here to provide you with expert guidance and support throughout the entire process, ensuring that your interests are protected every step of the way."
    },
]

export default servicesData;